import { useEffect, useRef, useState } from 'react';
import { fetchMaterialById } from '../../../features/materials/api';
import { resolveAudioUrl } from './narrationUtils';
import { Tooltip } from '../../common/Tooltip';
import styles from './ScenarioGenerator.module.css';

/** ナレーション音声プレーヤー（temporary_materialsから音声URLを取得して再生） */
export function NarrationPlayer({ materialId, hasAudio, unplayed, onPlay, inactive }: {
  materialId?: string | null;
  hasAudio: boolean;
  unplayed?: boolean;
  onPlay?: () => void;
  /** 「採用しない」中の非活性色表示 (再生自体は可能なまま色だけ落とす) */
  inactive?: boolean;
}) {
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (!materialId) {
      setAudioUrl(null);
      setIsPlaying(false);
      return;
    }
    let cancelled = false;
    setAudioUrl(null);
    setIsPlaying(false);
    (async () => {
      try {
        const material = await fetchMaterialById(materialId);
        if (cancelled) return;
        const url = await resolveAudioUrl({
          id: materialId,
          preview_url: material?.preview_url,
          source_url: material?.source_url,
          public_url: (material as any)?.public_url,
          storage_bucket: material?.storage_bucket,
          storage_path: material?.storage_path,
        });
        if (!cancelled) setAudioUrl(url);
      } catch {
        // マテリアル取得失敗時はURLなし
      }
    })();
    return () => { cancelled = true; };
  }, [materialId]);

  const togglePlay = () => {
    if (!audioRef.current || !audioUrl) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
      onPlay?.();
    }
  };

  return (
    <>
      {audioUrl && (
        <audio
          ref={audioRef}
          key={materialId}
          src={audioUrl}
          onEnded={() => setIsPlaying(false)}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          preload="metadata"
          style={{ display: 'none' }}
        />
      )}
      {hasAudio ? (
        <button
          type="button"
          onClick={togglePlay}
          title={isPlaying ? '停止' : inactive ? '採用なし（テイクを選ぶと採用されます）' : 'ナレーション音声を再生'}
          className={unplayed && !isPlaying && !inactive ? styles.narrationPlayUnplayed : undefined}
          style={{
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            padding: '0',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <img
            src={isPlaying ? "/button_stop_purple.svg" : "/button_play_purple.svg"}
            alt={isPlaying ? "停止" : "再生"}
            style={{ width: '24px', height: '24px', ...(inactive ? { filter: 'grayscale(100%) opacity(0.4)' } : {}) }}
          />
        </button>
      ) : (
        <Tooltip content="まずはナレーションを生成してください">
          <button
            type="button"
            disabled
            style={{
              border: 'none',
              background: 'transparent',
              cursor: 'default',
              padding: '0',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <img
              src="/button_play_purple.svg"
              alt="再生"
              style={{ width: '24px', height: '24px', filter: 'grayscale(100%) opacity(0.4)' }}
            />
          </button>
        </Tooltip>
      )}
    </>
  );
}
